import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ChipContext } from '@warrenbrasil/nebraska-web';
import { ProgressiveImage } from '@/modules/common/components/ProgressiveImage';

interface EmitEvents {
  (event: 'click'): void;
}
interface Props {
  image: string;
  title: string;
  subtitle: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'WalletCard',
  props: {
    image: null,
    title: null,
    subtitle: null
  },
  emits: ["click"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'click'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  image: string;
  title: string;
  subtitle: string;
}





const hasHover = ref(false);

const hasImage = computed(() => {
  return props.image;
});

function handleEnter() {
  hasHover.value = true;
}

function handleLeave() {
  hasHover.value = false;
}

function emitClick() {
  emit('click');
}

return { __sfc: true,emit, props, hasHover, hasImage, handleEnter, handleLeave, emitClick, NebraskaColors, BaseText, ChipContext, ProgressiveImage }
}

})